export const Fonts = {
  Lato: "lato",
  Ubuntu: "ubuntu",
  UbuntuBold: "Ubuntu-Bold",
};
